import { fmtMoney } from "./format";

export function unitConf(p, name) {
  return (p?.units || []).find((u) => u.unit === name) || null;
}

export function factorOf(p, name) {
  if (!name || name === p?.unit) return 1;
  const u = unitConf(p, name);
  return u ? Number(u.factor) || 1 : 1;
}

export function salePriceFor(p, unitName, customer) {
  const u = unitConf(p, unitName);
  if (u && Number(u.sale_price) > 0) return Number(u.sale_price);
  const base = customer && ["grossiste", "revendeur"].includes(customer.price_level) && p.wholesale_price > 0
    ? Number(p.wholesale_price) : Number(p.sale_price) || 0;
  return base * factorOf(p, unitName);
}

export function purchasePriceFor(p, unitName) {
  const u = unitConf(p, unitName);
  if (u && Number(u.purchase_price) > 0) return Number(u.purchase_price);
  return (Number(p?.purchase_price) || 0) * factorOf(p, unitName);
}

// Décomposition gloutonne : grandes unités ET sous-unités (factor < 1)
// ex : 10.05 tonne avec sac=0.05 → "10 tonne + 1 sac"
export function stockBreakdown(p, qtyBase) {
  const all = [{ unit: p?.unit || "", factor: 1 }, ...(p?.units || []).filter((u) => Number(u.factor) > 0)]
    .sort((a, b) => b.factor - a.factor);
  let rem = Number(qtyBase) || 0;
  const parts = [];
  for (const u of all) {
    const f = Number(u.factor);
    if (rem + 1e-9 < f) continue;
    const n = Math.floor((rem + 1e-9) / f);
    if (n > 0) {
      parts.push(`${n} ${u.unit}`);
      rem -= n * f;
    }
  }
  if (rem > 1e-9 || parts.length === 0) parts.push(`${+rem.toFixed(3)} ${p?.unit || ""}`);
  return parts.join(" + ");
}

export function resolveFactors(units, baseUnit) {
  const map = { [baseUnit]: 1 };
  const list = (units || []).filter((u) => u.unit);
  for (let k = 0; k < list.length + 2; k++) {
    let progressed = false;
    for (const u of list) {
      if (map[u.unit] != null) continue;
      const rel = u.relative_to || baseUnit;
      if (map[rel] != null) {
        const q = Number(u.qty) || Number(u.factor) || 0;
        map[u.unit] = u.direction === "per" ? (q ? map[rel] / q : 0) : q * map[rel];
        progressed = true;
      }
    }
    if (!progressed) break;
  }
  return map;
}

// Libellé d'option d'unité : « sac (20 par tonne) — 6 000 FCFA » ou « carton (×24) — 36 000 FCFA »
export function unitOptionLabel(baseUnit, u, price, cur) {
  const f = Number(u.factor) || 1;
  const conv = f >= 1 ? `×${f}` : `${+(1 / f).toFixed(3)} par ${baseUnit}`;
  return `${u.unit} (${conv}) — ${fmtMoney(price, cur)}`;
}
